import React, { useState, useEffect } from "react";
import styles from "../styles/Banner.module.css";
import banner from "../images/first-slide.png";
const Banner = () => {
  const [isTextVisible, setIsTextVisible] = useState(false); // To control visibility

  // useEffect to trigger after a set time (3 seconds in this case)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTextVisible(true);
    }, 2000); // Timer delay of 3 seconds

    // Cleanup function to clear the timeout if the component is unmounted or the timer changes
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <div className={styles.container}>
        <img alt="Banner" src={banner} className={styles.movingbox} />
        <div className={styles.textcontainer}>
          {isTextVisible && (
            <>
              <h1>باتری۱۰۰</h1>{" "}
              <p>
                بی <span> باتری </span>نمون
              </p>
            </>
          )}{" "}
          <div className={styles.containerr}>
            <div className={styles.movingbox}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
